import { useLocation } from "react-router-dom";
import { Action } from "../../../../common/enum";
import { OutletInput } from "../../components/OutletInput";
import { createInitialValue } from "../../utils";

export default function OutletEditInput() {
  const location = useLocation();
  const { data } = location.state as any;
  const initialValue = createInitialValue(data);

  return (
    <OutletInput
      reviewRoute={"/outlet/edit/review"}
      title={"Outlet Edit Input"}
      action={Action.UPDATE}
      initialData={initialValue}
    />
  );
}
